import type { ReactNode } from "react";

/** Icon tile + field stack (Coconut Telegraph–style rows). */
export function ClaimFieldRow({ icon, children }: { icon: ReactNode; children: ReactNode }) {
  return (
    <div className="claim-field-row">
      <div className="claim-field-icon-tile" aria-hidden>
        {icon}
      </div>
      <div className="claim-field-main">{children}</div>
    </div>
  );
}
